/*
 * Zendesk Web Widget (Classic) caricato dal tema, al posto dell'app embed Zendesk.
 *
 * Di suo il widget usa la lingua del browser; qui viene allineato alla lingua dello
 * storefront con zE('webWidget', 'setLocale', ...), appena lo snippet e' caricato.
 * Chiave del widget e lingua arrivano come data attribute dal tag di questo script
 * (sections/zendesk-web-widget.liquid), cosi' non c'e' JS inline.
 *
 * Lo snippet Zendesk cerca il proprio tag tramite id="ze-snippet": l'id va tenuto.
 */
(() => {
  const config = document.currentScript && document.currentScript.dataset;
  if (!config || !config.key || document.getElementById('ze-snippet')) return;

  const snippet = document.createElement('script');
  snippet.id = 'ze-snippet';
  snippet.async = true;
  snippet.src = `https://static.zdassets.com/ekr/snippet.js?key=${encodeURIComponent(config.key)}`;
  snippet.addEventListener('load', () => {
    if (config.locale && typeof window.zE === 'function') {
      window.zE('webWidget', 'setLocale', config.locale);
    }
  });
  document.body.appendChild(snippet);
})();
